import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { AuthUser } from '@/types/auth';

interface UserState {
  user: AuthUser | null;
  login: (user: AuthUser, token: string) => void;
  logout: () => void;
}

export const useUserStore = create<UserState>()(
  persist(
    (set) => ({
      user: null,
      login: (user, token) => {
        localStorage.setItem('auth_token', token);
        set({ user });
      },
      logout: () => {
        localStorage.removeItem('auth_token');
        set({ user: null });
      },
    }),
    {
      name: 'user-storage',
    }
  )
);
